// About Vuex

import states from './aboutStates.js'
import * as getters from './aboutGetters.js'
import * as mutations from './aboutMutations.js'
import * as actions from './aboutActions.js'

export default {
  namespaced: true,
  states,
  getters,
  mutations,
  actions
}
